import * as React from "react";

function SvgPhone(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.926 20A2.074 2.074 0 0020 17.927v-2.37a2.074 2.074 0 00-2.074-2.073h-3.954l-2.539 2.855a12.25 12.25 0 01-3.768-3.768l2.856-2.538V6.078a2.074 2.074 0 00-2.074-2.074h-2.37a2.074 2.074 0 00-2.073 2.074A13.938 13.938 0 0017.926 20zm-3.154-4.74h3.154a.296.296 0 01.297.297v2.37a.296.296 0 01-.297.296 12.078 12.078 0 01-4.878-1.022l1.724-1.94zm-8.99-9.182a.296.296 0 01.296-.296h2.37a.296.296 0 01.296.296v3.155l-1.938 1.724a12.077 12.077 0 01-1.025-4.879z"
        fill="#131B1F"
      />
    </svg>
  );
}

export default SvgPhone;
